export var EHeliMicPermissionState;
(function(EHeliMicPermissionState) {
    EHeliMicPermissionState[EHeliMicPermissionState["Prompt"] = 0] = "Prompt";
    EHeliMicPermissionState[EHeliMicPermissionState["Granted"] = 1] = "Granted";
    EHeliMicPermissionState[EHeliMicPermissionState["Denied"] = 2] = "Denied";
})(EHeliMicPermissionState || (EHeliMicPermissionState = {}));
